'use client'
import type { FC } from 'react'
import type { BrandsContextType } from '../context'
import { BrandsContext } from '../context'
import type { BrandsProps } from './Brands'
import Brands from './Brands'

export type BrandPageStdConfig = BrandsContextType & BrandsProps

interface BrandPageStdProps {
  config: BrandPageStdConfig
}

const BrandPageStd: FC<BrandPageStdProps> = ({ config }) => {
  return (
    <BrandsContext.Provider value={{ paths: config.paths }}>
      <Brands {...config} />
    </BrandsContext.Provider>
  )
}

export default BrandPageStd
